import { render, staticRenderFns } from "./TicketPrivateNotes.vue?vue&type=template&id=4be58bd5&"
import script from "./TicketPrivateNotes.vue?vue&type=script&lang=ts&"
export * from "./TicketPrivateNotes.vue?vue&type=script&lang=ts&"
import style0 from "./TicketPrivateNotes.vue?vue&type=style&index=0&id=4be58bd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports